import * as React from "react";
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "../../lib/utils";
import { inputBaseClass, inputSizeClass } from "./input";

export interface PasswordInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type"
> {
  inputSize?: "sm" | "default";
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, inputSize = "default", ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className="relative">
        <input
          data-slot="password-input"
          type={visible ? "text" : "password"}
          className={cn(
            inputBaseClass,
            inputSizeClass[inputSize],
            "pr-8",
            className,
          )}
          ref={ref}
          {...props}
        />
        <button
          data-slot="password-toggle"
          type="button"
          onClick={() => setVisible((prev) => !prev)}
          tabIndex={-1}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          className={cn(
            "absolute right-1 top-1/2 grid size-5 -translate-y-1/2 place-items-center rounded-sm",
            "text-text-tertiary",
            "transition-[background-color,color] duration-100 ease-out-fast",
            "hover:bg-hover hover:text-text",
            "focus-visible:outline-none focus-fill",
          )}
        >
          {visible ? (
            <EyeOff className="size-3.5" aria-hidden />
          ) : (
            <Eye className="size-3.5" aria-hidden />
          )}
        </button>
      </div>
    );
  },
);
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
